import React, { useEffect, useState } from 'react';
import { ClockIcon, TotalCustomerIcon, TotalEarningIcon, TotalEmployeeIcon } from '~/assets/icons';
import { AreaChart, Area } from 'recharts';
import DashboardStats from '../DashboardStats';
import { Box } from '@mui/material';
import { useAppDispatch } from '~/redux/hooks';
import { handleDashboardTop } from '~/thunks/dashboard/dashboard';

const chartData = [
  { value: 30 },
  { value: 40 },
  { value: 35 },
  { value: 50 },
  { value: 45 },
  { value: 40 },
  { value: 58 },
  { value: 30 },
  { value: 40 },
  { value: 35 },
  { value: 50 },
  { value: 45 },
  { value: 40 },
  { value: 58 },
];

const percentage = "5.46%";

const StatsChart: React.FC = () => {

  const dispatch = useAppDispatch();

  const [totalAccounts, setTotalAccounts] = useState(0);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [totalRevenue, setTotalRevenue] = useState(0);


  const fetchData = () => {
    dispatch(handleDashboardTop({})).unwrap()
      .then((reponse: any) => {
        let data = reponse.data;
        setTotalAccounts(data.totalAccounts);
        setTotalCustomers(data.totalCustomers);
        setTotalRevenue(data.totalRevenue);
      })
      .catch((error: any) => {

      })
      .finally(() => {

      });
  }

  useEffect(() => {
    fetchData();
  }, [])
  return (
    <Box className="w-full" >
      <Box className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
        <DashboardStats
          icon={<TotalEmployeeIcon />}
          value={totalAccounts}
          label="Total Employee"
          // percentage="+5.46%"
          percentage=""
          chart={
            <></>
            // <AreaChart
            //   width={140}
            //   height={80}
            //   data={chartData}
            //   margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
            // >
            //   <defs>
            //     <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
            //       <stop offset="0%" stopColor="#48CFA9" stopOpacity={20} /> 
            //       <stop offset="100%" stopColor="#48CFA9" stopOpacity={0} />
            //     </linearGradient>
            //   </defs>
            //   <Area
            //     type="monotone"
            //     dataKey="value"
            //     stroke="#48CFA9"
            //     fill="url(#colorValue)"
            //     fillOpacity={0.2}
            //     strokeWidth={2}
            //   />
            // </AreaChart>
          }
        />

        <DashboardStats
          icon={<TotalCustomerIcon />}
          value={totalCustomers}
          label="Total Customers"
          // percentage="-5.46%"
          percentage=""
          chart={
            <></>
            // <AreaChart
            //   width={140}
            //   height={80}
            //   data={chartData}
            //   margin={{ top: 0, right: 0, left: 0, bottom: 0 }}
            // >
            //   <defs>
            //     <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
            //       <stop offset="0%" stopColor="#2DB3FC" stopOpacity={20} /> 
            //       <stop offset="100%" stopColor="#2DB3FC" stopOpacity={0} />
            //     </linearGradient>
            //   </defs>
            //   <Area
            //     type="monotone"
            //     dataKey="value"
            //     stroke="#2DB3FC"
            //     fill="url(#colorValue)"
            //     fillOpacity={0.2}
            //     strokeWidth={2}
            //   />
            // </AreaChart>
          }
        />

        <DashboardStats
          icon={<TotalEarningIcon />}
          value={`$${totalRevenue}`}
          label="Total Earnings"
          // percentage="+5.46%"
          percentage=""
          chart={
            <></>
            // <AreaChart
            //   width={140}
            //   height={80}
            //   data={chartData}
            //   margin={{ top: 0, right: 0, left: 0, bottom: 0 }}

            // >
            //   <defs>
            //     <linearGradient id="colorValue" x1="0" y1="0" x2="0" y2="1">
            //       <stop offset="0%" stopColor="#48CFA9" stopOpacity={20} /> 
            //       <stop offset="100%" stopColor="#48CFA9" stopOpacity={0} />
            //     </linearGradient>
            //   </defs>
            //   <Area
            //     type="monotone"
            //     dataKey="value"
            //     stroke="#48CFA9"
            //     fill="url(#colorValue)"
            //     fillOpacity={0.2}
            //     strokeWidth={2}
            //   />
            // </AreaChart>
          }
        />

      </Box>
    </Box>
  );
};

export default StatsChart;